import {defineStore} from 'pinia'
import {ref, watch} from 'vue'
import {debounce} from 'lodash'

export const useLocalStore = defineStore(
  'local',
  () => {
    const profileId = ref<number>(NaN)
    const lang = ref<string>('en')
    const speechEngine = ref<'browser' | 'whisper'>('browser')
    const developerMode = ref(false)
    const autoFormat = ref(true)
    const viewMode = ref<'compact' | 'normal' | 'detailed'>('normal')
    const taskFilter = ref<{durationFilter: number | null; selectedTag: string | null}>({
      durationFilter: null,
      selectedTag: null,
    })

    return {
      profileId,
      lang,
      speechEngine,
      developerMode,
      autoFormat,
      viewMode,
      taskFilter,
    }
  },
  {
    persist: {
      storage: localStorage,
      pick: ['profileId', 'lang', 'speechEngine', 'developerMode', 'autoFormat', 'viewMode', 'taskFilter'],
    },
  }
)
